type GroupColor = {
  '50': string;
  '300': string;
  '400': string;
};

export const defaultColor = 'Blue';

export const groupColors: Record<string, GroupColor> = {
  Red: {
    '50': '#fef2f2',
    '300': '#fca5a5',
    '400': '#f87171',
  },
  Orange: {
    '50': '#fff7ed',
    '300': '#fdba74',
    '400': '#fb923c',
  },
  Amber: {
    '50': '#fffbeb',
    '300': '#fcd34d',
    '400': '#fbbf24',
  },
  Yellow: {
    '50': '#fef9c3',
    '300': '#fde047',
    '400': '#facc15',
  },
  Lime: {
    '50': '#f7fee7',
    '300': '#bef264',
    '400': '#a3e635',
  },
  Green: {
    '50': '#f0fdf4',
    '300': '#86efac',
    '400': '#4ade80',
  },
  Emerald: {
    '50': '#ecfdf5',
    '300': '#6ee7b7',
    '400': '#34d399',
  },
  Teal: {
    '50': '#f0fdfa',
    '300': '#5eead4',
    '400': '#2dd4bf',
  },
  Cyan: {
    '50': '#ecfeff',
    '300': '#67e8f9',
    '400': '#22d3ee',
  },
  Sky: {
    '50': '#ecfeff',
    '300': '#7dd3fc',
    '400': '#38bdf8',
  },
  Blue: {
    '50': '#eff6ff',
    '300': '#93c5fd',
    '400': '#60a5fa',
  },
  Indigo: {
    '50': '#eef2ff',
    '300': '#a5b4fc',
    '400': '#818cf8',
  },
  Violet: {
    '50': '#f5f3ff',
    '300': '#c4b5fd',
    '400': '#a78bfa',
  },
  Purple: {
    '50': '#faf5ff',
    '300': '#d8b4fe',
    '400': '#c084fc',
  },
  Fuchsia: {
    '50': '#fdf4ff',
    '300': '#f0abfc',
    '400': '#e879f9',
  },
  Pink: {
    '50': '#fdf2f8',
    '300': '#f9a8d4',
    '400': '#f472b6',
  },
  Rose: {
    '50': '#fff1f2',
    '300': '#fda4af',
    '400': '#fb7185',
  },
  Gray: {
    '50': '#f9fafb',
    '300': '#d1d5db',
    '400': '#9ca3af',
  },
};
